/* FLOWRIDE product variant helper. No dependencies. */
document.addEventListener('change', function (event) {
  const input = event.target.closest('[data-fr-variant]');
  if (!input) return;

  const root = input.closest('[data-fr-product]');
  if (!root) return;

  const price = root.querySelector('[data-fr-price]');
  const compare = root.querySelector('[data-fr-compare]');
  const button = root.querySelector('[data-fr-add]');

  if (price && input.dataset.price) price.textContent = input.dataset.price;

  if (compare) {
    if (input.dataset.compare) {
      compare.textContent = input.dataset.compare;
      compare.hidden = false;
    } else {
      compare.textContent = '';
      compare.hidden = true;
    }
  }

  if (button) {
    const available = input.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? (button.dataset.addText || 'Legg i handlekurv') : (button.dataset.soldText || 'Utsolgt');
  }
});

